<!-- eslint-disable camelcase -->
<script setup lang="ts">
import { watch, computed } from "vue";
import useVuelidate from "@vuelidate/core";

import { rules } from "./validators";
import { PersonData, PrescribedConditionTypes, StrokeCondition } from "@/entities/conditions";
import MedicalFormBuilder from "@/components/medicalConditionForms/MedicalFormBuilder.vue";
import { parseSchema } from "@/components/medicalConditionForms/schema";
import { useMedicalForm } from "../useMedicalForm";

import stroke from "./stroke.json";
import { Suggestion } from "@/entities/suggestion";

export interface Props{
    condition: StrokeCondition,
    personDetails: PersonData,
    subConditionSuggestion?: Suggestion | null,
}

const props = defineProps<Props>();

const emit = defineEmits<{
        (on:"update:condition", value: StrokeCondition): void
    }>();

const { onConditionUpdate, state } = useMedicalForm<{type: PrescribedConditionTypes.Stroke} & StrokeCondition>({
    ...props.condition,
    type: PrescribedConditionTypes.Stroke,
    medications: props.condition.medications || [],
}, emit);

const atleastOneSelected = computed(() => state.condition.stroke_type_CVA === "1" ||
    state.condition.stroke_type_SAH === "1" ||
    state.condition.stroke_type_CHB === "1" ||
    state.condition.stroke_type_TIA === "1");

const v$ = useVuelidate(rules, {
    atleastOneSelected,
});

watch(atleastOneSelected, () => {
    v$.value.atleastOneSelected.$touch();
});

</script>

<template>
    <MedicalFormBuilder
        :diagnosis-date="props.personDetails.dob"
        :schema="parseSchema(stroke)"
        :initial-form="state.condition"
        :person-details="props.personDetails"
        @update:form="onConditionUpdate"
    />

    <div
        v-if="v$.atleastOneSelected.$error"
        class="alert alert-danger text-center d-block"
    >
        {{ v$.atleastOneSelected.$errors[0].$message }}
    </div>
</template>
